<template>
  <div class="penengah">
    <v-snackbar
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      v-model="snackbar.show"
    >
      {{ snackbar.message }}
    </v-snackbar>
    <v-card style="margin-top: 250px">
    <v-breadcrumbs :items="item">
      <template v-slot:item="{ item }">
        <v-breadcrumbs-item
          :href="goToRoute(item.href)"
          :disabled="item.disabled"
        >
          {{ item.text }}
        </v-breadcrumbs-item>
      </template>
    </v-breadcrumbs>

    <v-card>
      <v-card-title class="text-h5 grey lighten-2">
        {{ $t("penengah") }} {{ title }}
      </v-card-title>

      <v-container>
        <v-form ref="formpenengah">
          <v-row>
            <v-col cols="12" sm="4">
              <!-- <v-autocomplete
                outlined
                dense
                v-bind:label="$t('negeri')"
                return-object
                :items="lookupnegeri"
                :item-text="item => item.negeriID +' - '+ item.negeri"
                item-value="negeriID"
                v-model="paparnegeriexport"
                :disabled="disablenegeri"
                v-on:change="paparlookupsample"
              ></v-autocomplete> -->

              <v-autocomplete
                outlined
                dense
                v-bind:label="$t('negeri')"
                return-object
                :items="lookupnegeri"
                :item-text="item => item.negeriID +' - '+ item.negeri"

                item-value="negeriID"
                v-model="detailNegeri"
                :disabled="disablenegeri"
                v-on:change="paparlookupsample"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="3">
              <v-autocomplete
                outlined
                dense
                v-bind:label="$t('sample')"
                return-object
                :items="lookupsample"
                item-text="sample"
                v-model="paparsample"
                v-on:change="paparpusinganexport"
                :disabled="disablesample"
                ref="fokuspaparsample"
              ></v-autocomplete>
            </v-col>

               <v-col cols="12" sm="3">
              <v-autocomplete
                outlined
                dense
                v-bind:label="$t('pusingan')"
                return-object
                :items="lookuppusingan"
                item-text="pusingan"
                v-model="paparpusinganexport"
              ></v-autocomplete>
            </v-col>
            <v-col class="text-right">
              <v-btn
                     color="blue white white--text"
                     @click="cari()">
                     <span class="material-icons">search</span> 
                    {{ $t("cari") }}</v-btn> 
              </v-col>

            <Overlay v-show="showOverlay"/>

             <v-col v-show="isShowing" class="text-right">
                 <v-btn type="button" color="red white white--text" 
               @click="downloadPDF('pdf')"><span class='fas fa-file-pdf' style='font-size:24px'></span>
               {{ $t("muatturun") }} 
          </v-btn>
           &nbsp;&nbsp;
          
          <v-btn type="button" color="green white white--text"
           @click="downloadExcel('xls')"><span class='fas fa-file-excel' style='font-size:24px'></span>
          {{ $t("muatturun") }} 
          </v-btn></v-col>
          </v-row>
          </v-form>

         <v-card-text>
         <v-simple-table ref="exportable_table" fixed-header dense class="table-bordered" id="table1">
             <thead>
            <tr>
                <th colspan="1" style="text-align: center; border: none;">
                  <img src="https://i.ibb.co/WBrF5yQ/JATANEGARA.png" alt="JataNegara" width="80" height="70">
              </th>
              <th colspan="6" style="text-align: center; border:none;" class="text-h6">
                  <strong>SISTEM SURVEI PENDAPATAN, PERBELANJAAN ISI RUMAH DAN KEMUDAHAN ASAS  <br>
                  PENDAPATAN ISI RUMAH BULANAN PENENGAH</strong>
              </th>
              <th colspan="1" style="text-align: center; border: none;">
                <img src="https://i.ibb.co/bX8FgBj/HIES.png" alt="HIES/BA" width="80" height="70">
              </th>
            </tr>
            <tr>
              <th rowspan="2"  style="text-align:center;"><strong>KATEGORI</strong></th>
              <th rowspan="2"  style="text-align:center;"><strong>2016</strong></th>
              <th rowspan="2"  style="text-align:center;"><strong>2019</strong></th>
              <th rowspan="2"  style="text-align:center;"><strong>2022 (TANPA WAJARAN)</strong></th>
              <th rowspan="2"  style="text-align:center;"><strong>2022 (BERWAJARAN)</strong></th>
              <th colspan="3" style="text-align:center;"><strong>KADAR PERTUMBUHAN TAHUNAN DIKOMPAUN (CAGR) (%)</strong></th>
            
              </tr>
              <tr> 
              <th style="text-align:center;" ><strong>2014 - 2016</strong></th>
              <th style="text-align:center;" ><strong>2016 - 2019</strong></th>
              <th style="text-align:center;" ><strong>2019 - 2022</strong></th>
 
              </tr>
              </thead>
 <!-- /-------------------------------------------------NEGERI---------------------------------------------------------              -->
              <tbody>
                <tr>
                     <td style="text-align:left;"><strong> {{detailNegeri.negeri}} :</strong></td>

                     <template v-for="item in dataz.data2016" >
                     <td v-if="item.row == '1' && item.col == '2' && item.DP == ''" :key="item.index" style="text-align:center;">
                        {{item.value}} 
                        <!-- negeri : {{item.NG}} row : {{item.row}} col : {{item.col}} -->
                     </td>
                     </template>

                     <template v-for="item in dataz.data2019" >
                     <td v-if="item.row == '1' && item.col == '3' && item.DP == ''" :key="item.index" style="text-align:center;">
                        {{item.value}} 
                      <!-- negeri : {{item.NG}} row : {{item.row}} col : {{item.col}} -->
                     </td>   
                     </template>

                    <!-- //--TANPA WAJARAN 2022-->
                     <td style="text-align:center;">
                         {{calculateJPKASBNeg()}}
                     </td>      

                    <!-- //-- WAJARAN 2022-->
                     <td style="text-align:center;">
                         {{calculateWajaranJPKASBNeg()}}
                     </td>           

                    <template v-for="item in dataz.data2015" >
                    <td v-if="item.row == '1' && item.col == '4' && item.DP == ''" :key="item.index" style="text-align:center;">
                        {{item.value}} 
                     <!-- {{item.value}} negeri : {{item.NG}} row : {{item.row}} col : {{item.col}} -->
                    </td>
                    </template>

                    <template v-for="item in dataz.data2018" >
                       <td v-if="item.row == '1' && item.col == '5' && item.DP == ''" :key="item.index" style="text-align:center;">
                        {{item.value}} 
                      <!-- negeri : {{item.NG}} row : {{item.row}} col : {{item.col}} -->
                    </td>   
                    </template>

                    <!-- //--PENENGAH CAGR %-->
                      
                    <td style="text-align:center;">
                         {{calculateCAGR2022Penengah('NEG')}}
                    </td>
                    
                </tr>

  <!-- //-----------------------------------------------------------STRATA--------------------------------------------------------- -->
                <tr>
                     <td colspan="8" style="text-align:left;"><strong>Strata</strong></td>
                </tr>
                      <!-- //..............BANDAR................. -->
                <tr>
                     <td style="text-align:left;">Bandar</td>

                     <template v-for="item in dataz.data2016" >
                     <td v-if="item.row == '2' && item.col == '2' && item.DP == ''" :key="item.index" style="text-align:center;">
                        {{item.value}} 
                     </td>
                     </template>

                     <template v-for="item in dataz.data2019" >
                     <td v-if="item.row == '2' && item.col == '3' && item.DP == ''" :key="item.index" style="text-align:center;">
                        {{item.value}} 
                     </td>   
                     </template>

                    <!-- //--TANPA WAJARAN PENENGAH 2022-->
                      <td style="text-align:center;">
                        {{jumlahjpksb1}}
                      </td>   
                      <!-- //--WAJARAN PENENGAH 2022-->
                      <td style="text-align:center;">
                        {{calculateStrataWajaran('1')}}
                      </td>

                    <template v-for="item in dataz.data2015" >
                    <td v-if="item.row == '2' && item.col == '4' && item.DP == ''" :key="item.index" style="text-align:center;">
                        {{item.value}} 
                      <!-- negeri : {{item.NG}} row : {{item.row}} col : {{item.col}} -->
                    </td>
                    </template>

                    <template v-for="item in dataz.data2018" >
                    <td v-if="item.row == '2' && item.col == '5' && item.DP == ''" :key="item.index" style="text-align:center;">
                          {{item.value}} 
                      <!-- negeri : {{item.NG}} row : {{item.row}} col : {{item.col}} -->
                    </td>   
                    </template>

                    <!-- //--PENENGAH CAGR %-->
                    <td style="text-align:center;">
                         {{calculateCAGR2022Penengah('Bandar')}}
                    </td>
                </tr>
                          <!-- //..............LUAR BANDAR................. -->
                <tr>
                      <td style="text-align:left;">Luar Bandar</td>
                      <template v-for="item in dataz.data2016" >
                      <td v-if="item.row == '3' && item.col == '2' && item.DP == ''" :key="item.index" style="text-align:center;">
                        {{item.value}}
                      </td>
                      </template>

                      <template v-for="item in dataz.data2019" >
                      <td v-if="item.row == '3' && item.col == '3' && item.DP == ''" :key="item.index" style="text-align:center;">
                         {{item.value}}
                      </td>   
                      </template>
                    
                     <!-- //--TANPA WAJARAN PENENGAH 2022-->
                      <td style="text-align:center;">
                        {{jumlahjpksb2}}
                      </td>  
                    <!-- <WAJARAN PENENGAH 2022-->
                      <td style="text-align:center;">
                        {{calculateStrataWajaran('2')}}
                      </td>

                      <template v-for="item in dataz.data2015" >
                      <td v-if="item.row == '3' && item.col == '4' && item.DP == ''" :key="item.index" style="text-align:center;">
                         {{item.value}}
                      </td>
                      </template>

                      <template v-for="item in dataz.data2018" >
                      <td v-if="item.row == '3' && item.col == '5' && item.DP == ''" :key="item.index" style="text-align:center;">
                         {{item.value}}
                      </td>   
                      </template>

                    <!-- //--PENENGAH CAGR %-->
                    <td style="text-align:center;">
                         {{calculateCAGR2022Penengah('LuarBandar')}}
                    </td>
                </tr>
<!-- /--------------------------------------------------BAHAGIAN KAUM---------------------------------------------------- -->
                <tr>
                     <td colspan="8" style="text-align:left;"><strong>Kaum :</strong></td>
                </tr>
                             <!-- //..............BUMIPUTRA................. -->
                <tr>
                    <td style="text-align:left;">Bumiputra</td>

                     <template v-for="item in dataz.data2016" >
                    <td v-if="item.row == '4' && item.col == '2' && item.DP == ''" :key="item.index" style="text-align:center;">
                      {{item.value}}
                    </td>
                    </template>
                    
                     <template v-for="item in dataz.data2019" >
                     <td v-if="item.row == '4' && item.col == '3' && item.DP == ''" :key="item.index" style="text-align:center;">
                      {{item.value}}
                     </td>   
                    </template>
                    
                    <!-- //--TANPA WAJARAN-->
                    <td style="text-align:center;">
                      {{calculateEtnik1}}
                    </td>  
                    <!-- //--WAJARAN-->
                    <td style="text-align:center;">
                      {{calculateBumiPenengahBerwajaran('1','1','1')}}
                    </td>

                    <template v-for="item in dataz.data2015" >
                    <td v-if="item.row == '4' && item.col == '4' && item.DP == ''" :key="item.index" style="text-align:center;">
                      {{item.value}}
                    </td>
                    </template>

                     <template v-for="item in dataz.data2018" >
                     <td v-if="item.row == '4' && item.col == '5' && item.DP == ''" :key="item.index" style="text-align:center;">
                      {{item.value}}
                     </td>   
                     </template>

                    <!-- //--PENENGAH CAGR %-->
                     <td style="text-align:center;">
                        {{calculateCAGR2022Penengah('KaumBumi')}}
                     </td>
                  </tr>

                        <!-- //...........CINA............. -->
                 <tr>
                     <td style="text-align:left;">Cina</td>

                     <template v-for="item in dataz.data2016" >
                    <td v-if="item.row == '5' && item.col == '2' && item.DP == ''" :key="item.index" style="text-align:center;">
                      {{item.value}}
                    </td>
                    </template>

                     <template v-for="item in dataz.data2019" >
                     <td v-if="item.row == '5' && item.col == '3' && item.DP == ''" :key="item.index" style="text-align:center;">
                      {{item.value}}
                     </td>   
                    </template>

                    <!-- //--TANPA WAJARAN-->
                    <td style="text-align:center;">
                      {{calculateEtnik2}}
                    </td>  
                    <!-- //--WAJARAN-->
                    <td style="text-align:center;">
                      {{calculateCinaPenengahBerwajaran('1','1','2')}}
                    </td>

                     <template v-for="item in dataz.data2015" >
                    <td v-if="item.row == '5' && item.col == '4' && item.DP == ''" :key="item.index" style="text-align:center;">
                      {{item.value}}
                    </td>
                    </template>

                     <template v-for="item in dataz.data2018" >
                     <td v-if="item.row == '5' && item.col == '5' && item.DP == ''" :key="item.index" style="text-align:center;">
                      {{item.value}}
                     </td>   
                     </template>

                     <td style="text-align:center;">
                        {{calculateCAGR2022Penengah('KaumCina')}}
                     </td>
                </tr>

                          <!-- //...........INDIA................ -->
                 <tr>
                     <td style="text-align:left;">India</td>

                     <template v-for="item in dataz.data2016" >
                     <td v-if="item.row == '6' && item.col == '2' && item.DP == ''" :key="item.index" style="text-align:center;">
                      {{item.value}}
                     </td>
                     </template>

                     <template v-for="item in dataz.data2019" >
                     <td v-if="item.row == '6' && item.col == '3' && item.DP == ''" :key="item.index" style="text-align:center;">
                      {{item.value}}
                     </td>   
                    </template>

                    <!-- //--TANPA WAJARAN-->
                    <td style="text-align:center;">
                      {{calculateEtnik3}}
                    </td> 
                    <!-- //--WAJARAN-->
                    <td style="text-align:center;">
                      {{calculateIndiaPenengahBerwajaran('1','1','3')}}
                    </td> 

                    <template v-for="item in dataz.data2015" >
                    <td v-if="item.row == '6' && item.col == '4' && item.DP == ''" :key="item.index" style="text-align:center;">
                      {{item.value}}
                    </td>
                    </template>

                    <template v-for="item in dataz.data2018" >
                    <td v-if="item.row == '6' && item.col == '5' && item.DP == ''" :key="item.index" style="text-align:center;">
                      {{item.value}}
                    </td>   
                    </template>

                    <td style="text-align:center;">
                        {{calculateCAGR2022Penengah('KaumIndia')}}
                    </td>
                </tr>
                            <!-- //..............LAIN-LAIN................. -->
                 <tr>
                    <td style="text-align:left;">Lain-lain</td>
                      <template v-for="item in dataz.data2016" >
                    <td v-if="item.row == '7' && item.col == '2' && item.DP == ''" :key="item.index" style="text-align:center;">
                      {{item.value}}
                    </td>
                    </template>

                     <template v-for="item in dataz.data2019" >
                     <td v-if="item.row == '7' && item.col == '3' && item.DP == ''" :key="item.index" style="text-align:center;">
                      {{item.value}}
                     </td>   
                    </template>

                     <!-- //--TANPA WAJARAN-->
                    <td style="text-align:center;">
                      {{calculateEtnik4}}
                    </td>  
                    <!-- //-- WAJARAN-->
                    <td style="text-align:center;">
                      {{calculateLainPenengahBerwajaran()}}
                    </td> 

                     <template v-for="item in dataz.data2015" >
                    <td v-if="item.row == '7' && item.col == '4' && item.DP == ''" :key="item.index" style="text-align:center;">
                      {{item.value}}
                    </td>
                    </template>

                     <template v-for="item in dataz.data2018" >
                     <td v-if="item.row == '7' && item.col == '5' && item.DP == ''" :key="item.index" style="text-align:center;">
                      {{item.value}}
                     </td>   
                    </template>

                    <!-- //--PENENGAH CAGR % -->
                    <td style="text-align:center;">
                        {{calculateCAGR2022Penengah('KaumLain')}}
                    </td>
                </tr>
                              <!-- //..............DAERAH PENTADBIRAN................. -->
                 <tr>
                     <td colspan="8" style="text-align:left;"><strong>Daerah Pentadbiran :</strong></td>
                </tr>
                <tr v-for="item in datazDaerah" :key="item.index" >
                        <!-- ------loop getlistDaerah----  -->
                        <td style="text-align: left">{{item.NamaDP }}</td>
                       <!-- -------loop getlookup_penengah ------ -->
                       <td style="text-align:center;">{{DP(item.NamaDP,2016) }}</td>
                       <td style="text-align:center;">{{DP(item.NamaDP,2019) }}</td>

                       <!-- ------PENENGAH TANPA WAJARAN------- -->
                       <td style="text-align:center;">{{calculateJPKASBDaerah(item.DP,1,1) }}</td>

                       <!-- ------PENENGAH WAJARAN------- -->
                       <td  style="text-align:center;">{{calculateJPKASBDaerahWajaran(item.DP,1,1) }}</td>
                        <!-- <td style="text-align:center;">{{jumlahJPKASBDaerah}}</td> -->

                       <!-- -------loop getlookup_penengah ------ -->
                       <td style="text-align:center;">{{DP(item.NamaDP,2015) }}</td>
                       <td style="text-align:center;">{{DP(item.NamaDP,2018) }}</td>

                       <!-- ------PENENGAH CAGR % ------- -->
                      <td style="text-align:center;">{{calculateCAGR2022PenengahDaerah(item.DP,3) }}</td>
                                         
                    </tr>
                
              </tbody>
            </v-simple-table>
          </v-card-text>
       
      </v-container>
    </v-card>
    </v-card>
  </div>
</template>
<script>
import Overlay from '../../components/Overlay'
import i18n from "@/i18n";
import axios from "../../plugins/axios";
import hidServices from "@/services/lookupField";
const negerilookup = new hidServices();
import getPusingan from "@/services/pusingan";
const pusingan = new getPusingan();


export default {
 components: {
  Overlay
},
async beforeMount(){
   var res = await pusingan.getPusinganDataAll();
   this.lookuppusingan = res;

   this.lookupsample = await pusingan.getSample();
  
},
  Name: "penengah",
  computed: {},
  setup() {},
  data: () => ({
    exportthn: "",
    exportbln: "",
    exportps: '',
    exportneg: '',
    snackbar: "",
   showOverlay: false,
    item: [
      {
        text: i18n.t("utama"),
        disabled: false,
        href: `paparanutama`,
      },
      {
        text: 'Pendapatan Isi Rumah Bulanan Penengah',
        disabled: true,
        href: "",
      },
    ],
    title: "",
    lookupnegeri: [],
    paparsample:"",
    paparpusinganexport: "",
    lookuppusingan: [],
    lookupsample: [],
    paparnegeri: "",
    paparnegeriexport: "",
    disablepusingan: true,
    peranan: "",
    disablenegeri: true,
    disablesample:true,
    dataz: [],
    detailNegeri:"",
    datez: [],
    sortedData:[],
    daerah: "",
    datazDaerah: [],
    datazlookuppenengah: [],
    dataJR2: [],
    medianFirst:"0",
    jumlahjpksb1:"",
    jumlahjpksb2:"",
    calculateEtnik1:"",
    calculateEtnik2:"",
    calculateEtnik3:"",
    calculateEtnik4:"",
    isShowing:false,
    wajaranAll: "",
    dataW: []
    // jumlahJPKASBDaerah:0,


  }),
  mounted() {
    this.$store.dispatch("localStorageuser");
    this.permulaan();
 
  },
  methods: {
    goToRoute(url) {
      return `/${i18n.locale}/${url}`;
    },

    downloadPDF: function () {
           
           var sTable = document.getElementById('table1').innerHTML;
     
     var style = "<style>";
     style = style + "body {font: 14px Calibri;}";
     style = style + "table {width: 100%; font: 12px Calibri;}";
     style = style + "table, th, td {border: solid 1px #DDD; border-collapse: collapse;";
     style = style + "padding: 2px 3px;text-align: center;}";
     style = style + "</style>";
     
     // CREATE A WINDOW OBJECT.
     var win = window.open( "http://www.domainname.ext/path.png",
                                  "DescriptiveWindowName");
     win.document.write('<html><head>');
     win.document.write('<title>Pendapatan Isi Rumah Bulanan Penengah</title>');   // <title> FOR PDF HEADER.
     win.document.write(style);          // ADD STYLE INSIDE THE HEAD TAG.
     win.document.write('</head>');
     win.document.write('<body>');
     
     win.document.write('<center>');
      win.document.write(`Negeri = `+this.detailNegeri.negeriID +' - '+this.detailNegeri.negeri);
     win.document.write('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');
     win.document.write('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');
     win.document.write('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');
     
     win.document.write(`Sample = `+this.paparsample.sample);
     win.document.write('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');
     win.document.write('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');
     win.document.write('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');
     
     win.document.write(`Pusingan = `+this.paparpusinganexport.pusingan);
     win.document.write('<br>');
     win.document.write('<br>');
     
     win.document.write(sTable);         // THE TABLE CONTENTS INSIDE THE BODY TAG.
     win.document.write('</body></html>');
     
     win.document.close(); 	// CLOSE THE CURRENT WINDOW.
     win.setTimeout(function () {
     win.print();    // PRINT THE CONTENTS.
       }, 100)
     },


     downloadExcel: function () {
    //format xls
    var uri = 'data:application/vnd.ms-excel;base64,';
  
    var base64 = function(s) {
        return window.btoa(unescape(encodeURIComponent(s)))
      },
      format = function(s, c) {
        return s.replace(/{(\w+)}/g, function(m, p) {
          return c[p];
        })
      }
    var sTable = document.getElementById("table1").innerHTML;
    var ctx = {
      worksheet: 'PendapatanPenengah',
      table: sTable
    };
 
    var style = "<style>";
    style = style + "body {font: 12px Calibri;}";
    style = style + "table {width: 100%; font: 12px Calibri;}";
    style = style + "table, th, td {border: solid 1px #DDD; border-collapse: collapse;";
    style = style + "padding: 2px 3px;text-align: center;}";
    style = style + "</style>";

    var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
    tab_text = tab_text + '<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>';

    tab_text = tab_text + '<x:Name>PendapatanPenengah</x:Name>';

    tab_text = tab_text + '<x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet>';
    tab_text = tab_text + '</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>';
    
    tab_text = tab_text + ('<center>');
    tab_text = tab_text + (`Negeri = `+this.detailNegeri.negeriID +' - '+this.detailNegeri.negeri);
    tab_text = tab_text + ('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');
    tab_text = tab_text + ('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');
    tab_text = tab_text + ('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');

    tab_text = tab_text + (`Sample = `+this.paparsample.sample);
    tab_text = tab_text + ('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');
    tab_text = tab_text + ('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');
    tab_text = tab_text + ('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');
    
    tab_text = tab_text + (`Pusingan = `+this.paparpusinganexport.pusingan);
    tab_text = tab_text + ('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');
    tab_text = tab_text + ('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');
    tab_text = tab_text + ('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');

    tab_text = tab_text + (style); 
    tab_text = tab_text + (sTable);  

    tab_text = tab_text + '</body></html>';
   
    var link = document.createElement("a");
    link.download = "PendapatanPenengah.xls";
    link.href = uri + base64(format(tab_text, ctx))
    link.click();
 
    // window.location.href = uri + window.btoa(tab_text);
  
},
// downloadExcel: function () {
//   var location = 'data:application/vnd.ms-excel;base64,';
// 	var excelTemplate = '<html> ' +
// 		'<head> ' +
// 		'<meta http-equiv="content-type" content="text/plain; charset=UTF-8"/> ' +
// 		'</head> ' +
// 		'<body> ' +
// 		document.getElementById("table1").innerHTML +
// 		'</body> ' +
// 		'</html>'
// 	window.location.href = location + window.btoa(excelTemplate);
// },

     async cari() {
       this.findPenengah()
       this.TanpaWajaranPenengah()
       this.lookupDaerah()
       this.isShowing="true"
       this.showOverlay = true;
       
    
    },

    async findPenengah() {
      try {
        const res = await axios.get(`${process.env.VUE_APP_API_URL}/JadualAwalan/getPenengah?NG=`+this.detailNegeri.negeriID+`&P=`+this.paparpusinganexport.id,{
        });
        this.dataz = res.data.data;

        // console.log(this.dataz)

      }
       catch (error) {
        this.errorDialog = true;
        setTimeout(() => (this.errorDialog = false), 2000);
        this.errMessage = "getData : " + error;
      }
    },

     async TanpaWajaranPenengah() {
      try {
        const res = await axios.get(`${process.env.VUE_APP_API_URL}/JadualAwalan/getDataPenengahTanpaWajaran?NG=`+this.detailNegeri.negeriID+`&P=`+this.paparpusinganexport.id+`&S=`+this.paparsample.id,{
        });
        // currData = res.data.data;
        this.dataW = res.data.data;
        
        this.jumlahjpksb1=this.calculateStrata('1')
        this.jumlahjpksb2=this.calculateStrata('2')
        this.calculateEtnik1=this.calculateEtnik('1')
        this.calculateEtnik2=this.calculateEtnik('2')
        this.calculateEtnik3=this.calculateEtnik('3')
        this.calculateEtnik4=this.calculateEtnik('4')
        this.showOverlay = false;
        // this.jumalahJPKASBDaerah=this.calculateJPKASBDaerah(item.DP,1,1)
      }
       catch (error) {
        this.errorDialog = true;
        setTimeout(() => (this.errorDialog = false), 2000);
        this.errMessage = "getData : " + error;
      }
    },
    async lookupDaerah() {
      try {
        const res = await axios.get(`${process.env.VUE_APP_API_URL}/JadualAwalan/getListDaerahPenengah?NG=`+this.detailNegeri.negeriID,{
        });
      
        this.datazDaerah = res.data.data.listDaerah;
        this.datazlookuppenengah = res.data.data.datalookuppenengah;
            
        //console.log(this.datazDaerah)
      }
       catch (error) {
        this.errorDialog = true;
        setTimeout(() => (this.errorDialog = false), 2000);
        this.errMessage = "getData : " + error;
      }
    },

   
    // ******************************* 2022 (TANPA WAJARAN) *****************************
     calculateJPKASBNeg(){
       
        var currData = this.dataW;
        var arrLength = currData.length;
        var jpkasb = 0;
        // var totalHID = 0;
        var listjpksbuntukcarimin = [];
        var listkumulatif = [];
        
        //kira JPKASB Negeri
       for(var i = 0;i < arrLength;i++){
         
              jpkasb = jpkasb + Number( currData[i].JPKASB);
              //untuk cari min
              listjpksbuntukcarimin.push(Number(currData[i].JPKASB));
              // console.log(jpkasb)
              // console.log(listjpksbuntukcarimin)
            }          
              return  this.calculatemediankumulatif(listjpksbuntukcarimin)
                 
     },

    calculatemediankumulatif(arrayjpkasb){
      // console.log(arrayjpkasb)
                var kirakumulatif = 0;
                var listkumulatif2 = [];

              if(arrayjpkasb.length < 1){
                  return dataToReturn = "-";
              }

              if(arrayjpkasb.length > 0){
                for(var y = 0;y < arrayjpkasb.length;y++){
                  kirakumulatif = kirakumulatif + 1/arrayjpkasb.length;
                  listkumulatif2.push(kirakumulatif)
                }
                  var medianFirst = 0;
                  var medianjpkasb = 0;
                  var half = 0;
                  arrayjpkasb.sort((a,b)=>a-b)
                

                  half = Math.floor(listkumulatif2.length / 2);

                  // console.log("luar" + half)
                  // console.log("papeje" + listkumulatif2.length % 2)
                  if (listkumulatif2.length % 2 == 0)
                  { 
                      // console.log("dalam" + half)
                    medianjpkasb = Number(arrayjpkasb[half - 1]);
                  }
                  else
                  {
                    // console.log("dalam2" + half)
                    medianjpkasb =  (Number(arrayjpkasb[half - 1]) + Number(arrayjpkasb[half])) / 2.0;
                  }
                  
                var dataToReturn = Number(medianjpkasb);
                if(isNaN(dataToReturn)){
                  return "-";
                }else{
                  return Math.round(dataToReturn);
                }
              }
           },

    calculateStrata(st){
        // var total = 0;
        var currData = this.dataW;
        var arrLength = currData.length;
        var jpkasb = 0;
        var totalHID = 0;
        var listjpksbuntukcarimin = [];
        var listjpksbuntukcarimin2 = [];
        
        //kira strata (st) bandar = 1 dan luar bandar = 2
        for(var i = 0;i < arrLength ;i++){
          // if(currData[i].JPKASB == null || currData[i].JPKASB == ""){
          //     currData[i].JPKASB = 0;
          // }
           if (st == 1) {
            
              if ((currData[i].ST == 1 || currData[i].ST == 2)){
                  totalHID = totalHID + 1
                  jpkasb = jpkasb + Number( currData[i].JPKASB);
                  listjpksbuntukcarimin.push(currData[i].JPKASB);
              }
          }
          if (st == 2) {
              if ((currData[i].ST == 0 || currData[i].ST >= 3)){
                  totalHID = totalHID + 1
                  jpkasb = jpkasb + Number( currData[i].JPKASB);
                  //total = Number(penkasar.toFixed(2));
                  //untuk cari min
                  listjpksbuntukcarimin2.push(currData[i].JPKASB);
              }
          }
        } 

        if (st == 1){
          // console.log("1")
          return  this.calculatemediankumulatif(listjpksbuntukcarimin)
          }
        if (st == 2){
          //  console.log("2")
          return  this.calculatemediankumulatif(listjpksbuntukcarimin2)
          }
                
        },

   calculateEtnik(et){
        
        var currData = this.dataW;
        var arrLength = currData.length;
        var jpkasb = 0;
        var totalHID = 0;
        var listjpksbuntukcarimin = [];
        var listjpksbuntukcarimin2 = [];
        var listjpksbuntukcarimin3 = [];
        var listjpksbuntukcarimin4 = [];
        
        //kira kaum- bumiputra, cina, india dan lain2        
        for(var i = 0;i < arrLength ;i++){
      
           if (et == 1) {
             
              if (currData[i].KKIRB <= 499999){
                totalHID = totalHID + 1
                jpkasb = jpkasb + Number( currData[i].JPKASB);
                // total = Number(jpkasb.toFixed(2));
                 listjpksbuntukcarimin.push(Number(currData[i].JPKASB));
                }
            }
          
          if (et == 2) {
               if (currData[i].KKIRB >= 511000 && currData[i].KKIRB <= 599999){
                totalHID = totalHID + 1
                jpkasb = jpkasb + Number( currData[i].JPKASB);
                // total = Number(jpkasb.toFixed(2));
                listjpksbuntukcarimin2.push(currData[i].JPKASB);
                }
            }

          if (et == 3) {
              if (currData[i].KKIRB >= 611000 && currData[i].KKIRB <= 699999){
                totalHID = totalHID + 1
                jpkasb = jpkasb + Number( currData[i].JPKASB);
                // total = Number(jpkasb.toFixed(2));
                listjpksbuntukcarimin3.push(currData[i].JPKASB);
                }
            }

          if (et == 4) {
              if (currData[i].KKIRB >= 711000 && currData[i].KKIRB <= 999999){
                totalHID = totalHID + 1
                jpkasb = jpkasb + Number( currData[i].JPKASB);
                // total = Number(jpkasb.toFixed(2));
                listjpksbuntukcarimin4.push(currData[i].JPKASB);
                }
            }
          }
        if (et == 1){
          // console.log("1")
          return  this.calculatemediankumulatif(listjpksbuntukcarimin)
          }
        if (et == 2){
          // console.log("2")
          return  this.calculatemediankumulatif(listjpksbuntukcarimin2)
          } 
        if (et == 3){
          // console.log("2")
          return  this.calculatemediankumulatif(listjpksbuntukcarimin3)
          }
        if (et == 4){
          // console.log("2")
          return  this.calculatemediankumulatif(listjpksbuntukcarimin4)
          }  
              //  return  this.calculatemediankumulatif(listjpksbuntukcarimin)
      },
      
    DP(dp,tahun){
      var total = 0;
      let daerah = 0;
               
      for(var i = 0;i < this.datazlookuppenengah.length ;i++){
        
          if (this.datazlookuppenengah[i].NamaDP == dp && this.datazlookuppenengah[i].Tahun == tahun){
             return this.datazlookuppenengah[i].value
         // this.daerah =  Number( currData[i].NamaDP);
          }
      }
    },

    calculateJPKASBDaerah(dp){
      
      var currData = this.dataW;
      var arrLength = currData.length;
      var jpkasbdaerah = 0;
      var totalHID = 0; 
      var listjpksbdaerah = [];

      //kira JPKASB Daerah
      for(var i = 0;i < arrLength ;i++){
            //console.log( currData[i].DP)
        if(currData[i].JPKASB == null || currData[i].JPKASB == ""){
            currData[i].JPKASB = 0;
            //  listjpksbstratamin.push(currData[i].JPKASB);
        }
         if (currData[i].DP == dp){
                totalHID = totalHID + 1
                jpkasbdaerah = jpkasbdaerah + Number( currData[i].JPKASB);
                // total = Number(jpkasb.toFixed(2));
                 listjpksbdaerah.push(currData[i].JPKASB);
            }
        }
               return  this.calculatemediankumulatif(listjpksbdaerah)
    },

 // ******************************* 2022 (TAMAT TANPA WAJARAN) *****************************
// ******************************** 2022 ( WAJARAN) ****************************************
      calculatemediankumulatifWajaran(listjpksbuntukcarimin, arrayjpkasb){
      // console.log(arrayjpkasb)
              var kirakumulatif = 0;
              var dataToReturn = "-";
              var listkumulatif2 = [];
              
              if(arrayjpkasb.length < 1){
                  return dataToReturn = "-";
              }

              if(arrayjpkasb.length > 0){
                for(var j = 0;j < arrayjpkasb.length;j++){
                  if(listkumulatif2 == 0){
                    kirakumulatif = arrayjpkasb[j].nisbahWajaran
                    listkumulatif2.push(arrayjpkasb[j].nisbahWajaran)
                  }else{
                    kirakumulatif = kirakumulatif + arrayjpkasb[j].nisbahWajaran;
                    listkumulatif2.push(arrayjpkasb[j].nisbahWajaran)
                  }
                }
                
                  var medianFirst = 0;
                  var medianjpkasb = 0;
                  var half = 0;
                  listjpksbuntukcarimin.sort((a,b)=>a-b)
                  
                  half = Math.floor(listkumulatif2.length / 2);

                  if (listkumulatif2.length % 2 == 0)
                  { 
                    medianjpkasb = Number(listjpksbuntukcarimin[half - 1]);
                  }
                  else
                  {
                    medianjpkasb =  (Number(listjpksbuntukcarimin[half - 1]) + Number(listjpksbuntukcarimin[half])) / 2.0;
                  }
                
                dataToReturn = Number(medianjpkasb);
                if(isNaN(dataToReturn)){
                  return "-";
                }else{
                  return Math.round(dataToReturn);
                }
              }
           },
      calculateWajaranJPKASBNeg(){
       
        var currData = this.dataW;
        var listjpksbuntukcarimin = [];
        var TotalWajaran = 0;
        var arrLength = currData.length;
        var listdataWajaran = [];
        if(arrLength>0){
           
        
        //kira JPKASB Negeri
       for(var i = 0;i < arrLength;i++){
               TotalWajaran = TotalWajaran + Number(currData[i].wajaran);
              listjpksbuntukcarimin.push(Number(currData[i].JPKASB));
              listdataWajaran.push(currData[i]);
            }          
              return  this.calculatemediankumulatifWajaran(listjpksbuntukcarimin, listdataWajaran)
        }
        // var nisbahWjpkasb = 0;
        // var totalHID = 0;
        
                 
     },
      
      calculateStrataWajaran(st){
        var currData = this.dataW;
        var arrLength = currData.length;
        let jpkasb = 0;
        var totalWajaran = 0;
        var listjpksbuntukcarimin = [];
        var listdataWajaran = [];

        //kira JPKASB 
        // kira wajaran sahaja
        for(var x = 0;x < arrLength ;x++){
          if (st == 1) {
              //if (currData[x].sts == 1 || currData[x].ST == 2){
              if (currData[x].sts == 1){
                totalWajaran = totalWajaran + Number(currData[x].wajaran);
                }
          }
          if (st == 2) {
              //if (currData[x].ST == 0 || currData[x].ST >= 3){
              if (currData[x].sts == 2){
                totalWajaran = totalWajaran + Number(currData[x].wajaran);
                }
          }
        }
       
        for(var y = 0;y < arrLength ;y++){
          if (st == 1) {
              //if (currData[y].ST == 1 || currData[y].ST == 2){
              if (currData[y].sts == 1){
                currData[y].nisbahWajaran = Number(currData[y].wajaran) / Number(totalWajaran);
                listjpksbuntukcarimin.push(currData[y].JPKASB);
                listdataWajaran.push(currData[y]);
              }
          }
          if (st == 2) {
              //if (currData[y].ST == 0 || currData[y].ST >= 3){
              if (currData[y].sts == 2){

                currData[y].nisbahWajaran = Number(currData[y].wajaran) / Number(totalWajaran);
                listjpksbuntukcarimin.push(currData[y].JPKASB);
                listdataWajaran.push(currData[y]);
              }
            }
          }
            return  this.calculatemediankumulatifWajaran(listjpksbuntukcarimin, listdataWajaran)
      },

      calculateBumiPenengahBerwajaran(){
        
        var currData = this.dataW;
        var arrLength = currData.length;
        let jpkasb = 0;
        var totalWajaran = 0;
        var listjpksbuntukcarimin = [];
        var listdataWajaran = [];

        //kira JPKASB 
        // kira wajaran sahaja
        for(var x = 0;x < arrLength ;x++){
              if (currData[x].KKIRB <= 499999 ){
                totalWajaran = totalWajaran + Number(currData[x].wajaran);
              }
        }
       
        for(var y = 0;y < arrLength ;y++){
              if (currData[y].KKIRB <= 499999 ){
                currData[y].nisbahWajaran = Number(currData[y].wajaran) / Number(totalWajaran);
                listjpksbuntukcarimin.push(currData[y].JPKASB);
                listdataWajaran.push(currData[y]);
              }
          }
            return  this.calculatemediankumulatifWajaran(listjpksbuntukcarimin, listdataWajaran)   
      },

      calculateCinaPenengahBerwajaran(){
        
        var currData = this.dataW;
        var arrLength = currData.length;
        let jpkasb = 0;
        var totalWajaran = 0;
        var listjpksbuntukcarimin = [];
        var listdataWajaran = [];

        //kira JPKASB 
        // kira wajaran sahaja
        for(var x = 0;x < arrLength ;x++){
              if (currData[x].KKIRB >= 511000 && currData[x].KKIRB <= 599999){
                totalWajaran = totalWajaran + Number(currData[x].wajaran);
              }
        }
       
        for(var y = 0;y < arrLength ;y++){
              if (currData[y].KKIRB >= 511000 && currData[y].KKIRB <= 599999){
                currData[y].nisbahWajaran = Number(currData[y].wajaran) / Number(totalWajaran);
                listjpksbuntukcarimin.push(currData[y].JPKASB);
                listdataWajaran.push(currData[y]);
              }
          }
            return  this.calculatemediankumulatifWajaran(listjpksbuntukcarimin, listdataWajaran)   
      },

      calculateIndiaPenengahBerwajaran(){
        
        var currData = this.dataW;
        var arrLength = currData.length;
        let jpkasb = 0;
        var totalWajaran = 0;
        var listjpksbuntukcarimin = [];
        var listdataWajaran = [];

        //kira JPKASB 
        // kira wajaran sahaja
        for(var x = 0;x < arrLength ;x++){
              if (currData[x].KKIRB >= 611000 && currData[x].KKIRB <= 699999){
                totalWajaran = totalWajaran + Number(currData[x].wajaran);
              }
        }
       
        for(var y = 0;y < arrLength ;y++){
              if (currData[y].KKIRB >= 611000 && currData[y].KKIRB <= 699999){
                currData[y].nisbahWajaran = Number(currData[y].wajaran) / Number(totalWajaran);
                listjpksbuntukcarimin.push(currData[y].JPKASB);
                listdataWajaran.push(currData[y]);
              }
          }
            return  this.calculatemediankumulatifWajaran(listjpksbuntukcarimin, listdataWajaran)   
      },

      calculateLainPenengahBerwajaran(){
        
        var currData = this.dataW;
        var arrLength = currData.length;
        let jpkasb = 0;
        var totalWajaran = 0;
        var listjpksbuntukcarimin = [];
        var listdataWajaran = [];

        //kira JPKASB 
        // kira wajaran sahaja
        for(var x = 0;x < arrLength ;x++){
              if (currData[x].KKIRB >= 711000 && currData[x].KKIRB <= 999999) {
                totalWajaran = totalWajaran + Number(currData[x].wajaran);
              }
        }
       
        for(var y = 0;y < arrLength ;y++){
              if (currData[y].KKIRB >= 711000 && currData[y].KKIRB <= 999999) {
                currData[y].nisbahWajaran = Number(currData[y].wajaran) / Number(totalWajaran);
                listjpksbuntukcarimin.push(currData[y].JPKASB);
                listdataWajaran.push(currData[y]);
              }
          }
            return  this.calculatemediankumulatifWajaran(listjpksbuntukcarimin, listdataWajaran)   
      },
      
     
    calculateJPKASBDaerahWajaran(dp){
      
      var currData = this.dataW;
      var arrLength = currData.length;
      var jpkasbdaerah = 0;
      var totalHID = 0; 
      var listjpksbdaerah = [];

      //kira JPKASB Daerah
      for(var i = 0;i < arrLength ;i++){
            //console.log( currData[i].DP)
        if(currData[i].JPKASB == null || currData[i].JPKASB == ""){
            currData[i].JPKASB = 0;
            //  listjpksbstratamin.push(currData[i].JPKASB);
        }
         if (currData[i].DP == dp){
                totalHID = totalHID + 1
                jpkasbdaerah = jpkasbdaerah + Number( currData[i].JPKASB);
                // total = Number(jpkasb.toFixed(2));
                 listjpksbdaerah.push(currData[i].JPKASB);
            }
        }
               return  this.calculatemediankumulatif(listjpksbdaerah)
    },

    // ******************************* 2022 (TAMAT WAJARAN) *****************************
    // ******************************* MULA PENENGAH 2022 (CAGR %) *****************************

      calculateCAGR2022Penengah(typeST){

      if(this.dataz != ''){
        var row = '';
        var col = '';
        var conBerwajaran = 0;

        // ***** Pendapatan Purata CAGR 2022 Jumlah
        if(typeST == 'NEG'){
          row =  "1"  
          col = "3"
          conBerwajaran =this.calculateWajaranJPKASBNeg()
        }
         
         // ***** Pendapatan Purata CAGR 2022 Strata
         if(typeST == 'Bandar'){
          row =  "2"  
          col = "3"
          conBerwajaran = this.calculateStrataWajaran('1')
        }
         if(typeST == 'LuarBandar'){
          row =  "2"  
          col = "3"
          conBerwajaran = this.calculateStrataWajaran('2')
        }
        

        // ***** Pendapatan Purata CAGR 2022 Bumiputera
        if(typeST == 'KaumBumi'){
          row =  "4"  
          col = "3"
          conBerwajaran = this.calculateBumiPenengahBerwajaran('1','1','1')
        }

        if(typeST == 'KaumCina'){
          row =  "5"  
          col = "3"
          conBerwajaran = this.calculateCinaPenengahBerwajaran('1','1','2')
        }

        if(typeST == 'KaumIndia'){
          row =  "6"  
          col = "3"
          conBerwajaran = this.calculateIndiaPenengahBerwajaran('1','1','3')
        }

        if(typeST == 'KaumLain'){
          row =  "7"  
          col = "3"
          conBerwajaran = this.calculateLainPenengahBerwajaran()
        }

            var currData = this.dataz.data2019;
            var valuePurata = 0;
            // console.log()
            for(var y = 0; y<currData.length; y++){
              if(this.dataz.data2019[y].row == row && this.dataz.data2019[y].col == col ){
                  valuePurata = this.dataz.data2019[y].value
              }
            }
              
           var removecomma = valuePurata.replace(/,/g, '')
       
           var totalPurata = Number(conBerwajaran) / Number(removecomma)
            
           var data = Math.log(totalPurata)
           var dataToReturn = Number(data) / 0.03

               if(isNaN(dataToReturn)){
               return "-";
               }else{
               return dataToReturn.toFixed(1);
               // return dataToReturn.toFixed(1);
        }
      }
    
    },
// ------------------------------PENENGAH  CAGR 2022 DAERAH---------------------------------

    calculateCAGR2022PenengahDaerah(Daerah,col){
     
      if(this.dataz != ''){
          // console.log(this.dataz.data2019)
       
        let obj = this.dataz.data2019.find(o => o.DP == Daerah && o.col == col);
        var conBerwajaran = obj.value;
        var WajaranDaerah = this.calculateJPKASBDaerahWajaran(Daerah,1,1)
        var removecomma = conBerwajaran.replace(/,/g, '')
        var totalPurata = Number(WajaranDaerah) / Number(removecomma)
        var data = Math.log(totalPurata)
        var dataToReturn = Number(data) / 0.03

               if(isNaN(dataToReturn)){
               return "-";
               }else{
               return dataToReturn.toFixed(1);
               // return dataToReturn.toFixed(1);
        }
       }
    
    },

// ..............................................................
    async permulaan() {
      //this.negeri = this.paparnegeriexport.negeri; 
      this.peranan = this.$store.state.localStorageuser.role;
      this.paparnegeriexport = this.$store.state.localStorageuser.kodneg;
      let negeri = await negerilookup.getNegeri();
      let role = ["PP", "PO", "FE", "RESPONDENT"]
      this.disablenegeri = role.includes(this.peranan) === true
          ? true
          : false;
      this.disablesample = role.includes(this.peranan) !== true
          ? true
          : false;
      const Negeri = [];
      negeri.data.data.forEach(async function (element) {
        if ((element.negeri !== "Admin") && (element.negeri !== "Responden")) {
          Negeri.push({
            negeriID: `${element.negeriID}`,
            negeri: `${element.negeri}`,
          });
        }
      });
      this.lookupnegeri = Negeri;
      
      for(var i =0;i<this.lookupnegeri.length;i++){
        if(this.lookupnegeri[i].negeriID == this.paparnegeriexport){
          this.detailNegeri = this.lookupnegeri[i];
        }
      }

    },

    async paparlookupsample(){
      
      this.negeri = this.paparnegeriexport.negeri; 
      this.disablesample = false;
      this.paparsample = "";
      this.paparpusinganexport = "";
      // this.paparsampleexport();
    },
   },
  //   paparNegeri(){
    
  //   if (this.Tahun === 2016){
  //     if (this.row === 1 && this.col === 2){
  //       this.NG16 = ""
  //     }
  //   }
      
  //   }
    watch:{
    paparnegeriexport(val){ 
      this.detailNegeri = val; 
    },
    //  detailNegeri(){
    //   this.lookupDaerah();
    //   }
  }
};
</script>
<style scoped>
table {
 width: 100%;
 border-collapse: collapse;
 margin: 50px auto;
}
/* tr {
 background: #eee;
} */

td,
th {
 padding: 10px;
 border: 1px solid #ccc;
 text-align: left;
 font-size: 18px;
}
</style>


          